import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';
import { Link } from 'react-router-dom';

const Body = (props) => (

    <div>
        {
            !props.orderListSales.list || props.orderListSales.list.length == 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="row m-0 mb-1  text-center"  >
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
                            <h3>Total Orders: {props.orderListSales.total}</h3>
                            <h3>Total Paid Amount: {getDollarFormat(props.orderListSales.totalPaidAmount)}</h3>
                        </div>
                    </div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {props.beginDate ?
                                <p><i>From</i> <b>{moment(props.beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {props.endDate ? <b>{moment(props.endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    <br />
                    <div className="table-responsive">
                        {
                            props.orderListSales.list.map(item => {
                                return (

                                    <div className="row m-0 mb-2  text-center"  >
                                        <div className="row m-0 mb-2">
                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-center">
                                                <label>Order Number</label>
                                                <h4 className="m-0 grey-text"><Link to={`/admin/orders/detail/${item.orderNumber}`} target="_blank">{item.orderNumber}</Link></h4>
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 text-center">
                                                <label>Created Time</label>
                                                <h4 className="m-0 grey-text">{item.date}</h4>
                                            </div>
                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-center">
                                                <label>Total Paid Amount</label>
                                                <h4 className="m-0 grey-text">{getDollarFormat(item.totalPaidAmount)}</h4>
                                            </div>
                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-center">
                                                <label>Products Count</label>
                                                <h4 className="m-0 grey-text">{item.numItems}</h4>
                                            </div>
                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-center">
                                                <label>Type and Platform</label>
                                                <h4 className="m-0 grey-text">{item.type}</h4>
                                            </div>
                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-center">
                                                <label>Payment InStore/Online</label>
                                                <h4 className="m-0 grey-text">{item.paid}</h4>
                                            </div>
                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-center">
                                                <label>Payment Method</label>
                                                <h4 className="m-0 grey-text">{item.paymentMethod}</h4>
                                            </div>
                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-center">
                                                <label>Payment Card Type</label>
                                                <h4 className="m-0 grey-text">{item.paymentCardType}</h4>
                                            </div>
                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-center">
                                                <label>Delivery Method</label>
                                                <h4 className="m-0 grey-text">{item.delivery}</h4>
                                            </div>
                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-center">
                                                <label>Manual Approval</label>
                                                <h4 className="m-0 grey-text">{item.manualApproval}</h4>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                    </div>
                </div>
        }
    </div>
);

export default Body;